'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notifyBySound = undefined;

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _audio = require('./audio');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupNotifier = function setupNotifier() {
  if (typeof window.Audio !== 'function') {
    return _emptyFunction2.default;
  }

  var canPlay = true;
  var focusEvent = null;
  var playPromise = null;

  var playSafely = function playSafely() {
    var notificationSound = new window.Audio(_audio.notification);
    if (canPlay) {
      canPlay = false;
      playPromise = notificationSound.play();
      if (playPromise !== undefined) {
        playPromise.then(function () {
          canPlay = true;
        }).catch(function () {
          // notification prevented
          canPlay = true;
        });
      } else {
        canPlay = true;
      }
    }
  };

  return function (isAdmin) {
    playSafely();

    if (isAdmin) {
      window.removeEventListener('focus', focusEvent);

      playSafely();

      // clear the interval if a user focus into the app
      focusEvent = window.addEventListener('focus', function () {
        window.removeEventListener('focus', focusEvent);
      });
    }
  };
};

var notifyBySound = exports.notifyBySound = setupNotifier();